import { useEffect } from 'react';
const useOutsideClick = (refs, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            let isOutsideClick = true;
            for (const ref of refs) {
                if (ref.current && ref.current.contains(event.target)) {
                    isOutsideClick = false;
                    break;
                }
            }
            if (isOutsideClick) {
                callback();
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [refs, callback]);
};
export default useOutsideClick;
